import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { Header, Footer } from './components/layout';

export function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isTerraRoute = location.pathname.startsWith('/terra');
  const showChrome = !isAdminRoute && !isTerraRoute;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (location.hash) return;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ThemeProvider>
      <AuthProvider>
        {showChrome && <Header />}
        <main>
          <Outlet />
        </main>
        {showChrome && <Footer />}
      </AuthProvider>
    </ThemeProvider>
  );
}
